import React from 'react';
import styles from './SubscriptionGuide.module.css';

const SubscriptionGuide = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Upgrade or Cancel Your ToxBox Subscription</h2>
      <p className={styles.description}>
        Managing your ToxBox subscription is simple. Whether you want to explore more features or discontinue the service, you can do it directly from your dashboard.
      </p>

      <div className={styles.section}>
        <h4 className={styles.subheading}>How to Upgrade Your Plan:</h4>
        <ul className={styles.list}>
          <li>Log in to your ToxBox dashboard.</li>
          <li>Go to the Billing or Subscription section.</li>
          <li>Click “Upgrade Plan.”</li>
          <li>Choose the desired plan based on your need</li>
          <li>Confirm payment details and activate the new plan.</li>
          <li>Your upgraded features will be available instantly.</li>
        </ul>
      </div>

      <div className={styles.section}>
        <h4 className={styles.subheading}>How to Cancel Your Subscription:</h4>
        <ul className={styles.list}>
          <li>Log in to your dashboard.</li>
          <li>Navigate to Billing &gt; Manage Subscription.</li>
          <li>Click “Cancel Subscription.”</li>
          <li>Choose a reason (optional) and confirm cancellation.</li>
          <li>Your plan will remain active until the end of the billing cycle, after which it will not renew.</li>
        </ul>
      </div>
    </div>
  );
};

export default SubscriptionGuide;
